import { useContext, useMemo } from 'react';

import { GlobalContext } from '@context/GlobalContext';

/**
 * Custom hook to get the wg_914_weegio feature flag value from core configs
 */

const useWeegioFeatureFlag = (): {
  isWeegioHomepageBannerEnabled: boolean;
  isWeegioAppBannerEnabled: boolean;
  isWeegioSprinklrChatEnabled: boolean;
} => {
  const { userCentricCoreConfigs } = useContext(GlobalContext);

  return useMemo(() => {
    const weegioFeatureFlag = userCentricCoreConfigs?.find(
      (coreConfig) => coreConfig.key === 'wg_914_weegio',
    )?.value;

    const parsedWeegioFeatureFlag = JSON.parse(weegioFeatureFlag ?? '{}');

    return {
      isWeegioHomepageBannerEnabled: parsedWeegioFeatureFlag?.weegio_homepage_banner === '1',
      isWeegioAppBannerEnabled: parsedWeegioFeatureFlag?.weegio_app_banner === '1',
      isWeegioSprinklrChatEnabled: parsedWeegioFeatureFlag?.weegio_sprinklr_chat === '1',
    };
  }, [userCentricCoreConfigs]);
};

export default useWeegioFeatureFlag;
